import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { P2UpdateProcedureGet, P2UpdateProcedureService } from '@app/services/p2-update-procedure.service';

@Component({
    selector: 'tt-p2-update-procedure-edit',
    templateUrl: './p2-update-procedure-edit.component.html',
    styleUrls: ['./p2-update-procedure-edit.component.css'],
    standalone: false,
})
export class P2UpdateProcedureEditComponent implements OnInit, OnChanges {
    @Input() public p2UpdateProcedureKeyno?: string;

    @Input() public inline = false;

    @Output() public onSave = new EventEmitter<void>();

    public page?: P2UpdateProcedureGet;

    public saving = false;

    public readonly tabletSize: MediaQueryList;

    private navigator?: TTViewNavigator;

    constructor(
        private procedureService: P2UpdateProcedureService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) navigator?: TTViewNavigator,
    ) {
        this.tabletSize = layout.getMediaQueries().tablet;
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving) return;

        this.saving = true;

        try {
            await this.procedureService.saveProcedure(this.page);

            if (this.tabletSize.matches && this.inline) {
                this.onSave.emit();
            } else {
                await this.navigator?.back();
            }
        } catch {
            // Keep the editor open and unlock saving so the user can retry.
        } finally {
            this.saving = false;
        }
    }

    public ngOnInit(): void {
        if (!this.p2UpdateProcedureKeyno) {
            const routeKeyno = this.navigator?.params['p2_updateprocedure_keyno'];

            if (routeKeyno !== undefined && routeKeyno !== null) {
                this.p2UpdateProcedureKeyno = `${routeKeyno}`;
                void this.loadProcedure(this.p2UpdateProcedureKeyno);
            }
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        const keyno = changes['p2UpdateProcedureKeyno']?.currentValue;

        if (keyno !== undefined && keyno !== null && keyno !== '') {
            this.p2UpdateProcedureKeyno = `${keyno}`;
            void this.loadProcedure(this.p2UpdateProcedureKeyno);
        }
    }

    private async loadProcedure(keyno: string): Promise<void> {
        this.page = await this.procedureService.getProcedure({ p2_updateprocedure_keyno: keyno });
    }
}
